<template>
    <section class="section_emploees">
        <div class="header_emploee">
            <p class="characteristics_title_meter">
                Акции конкурсы реклама
            </p>
            <div class="box_button_header_emploee">
                <div class="box_button_back_emploee">
                    <RouterLink
                        to="/employees"
                        class="button_standart"
                    >
                        Вернуться
                    </RouterLink>
                </div>
                <ModalHeader />
            </div>
        </div>

        <p
            v-if="isLoading"
            class="stock_status_text"
        >
            Загрузка...
        </p>
        <p
            v-else-if="!stocks.length"
            class="stock_status_text"
        >
            Сейчас нет активных акций
        </p>
        <div
            v-else
            class="section_stock"
        >
            <StockItem
                v-for="stock in stocks"
                :key="stock.id"
                :title="stock.title"
                :thumbnail-url="stock.thumbnailUrl"
                :date="stock.createdAt"
            />
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ModalHeader from '@/shared/components/modal-header/ModalHeader.vue';
import { API_ENDPOINTS } from '@/shared/constants';
import {
    StockItem,
} from './components';

const stocks = ref([]);
const isLoading = ref(true);

const fetchStocks = async () => {
    try {
        const response = await fetch(API_ENDPOINTS.STOCKS);

        stocks.value = await response.json();
    } catch (e) {
        stocks.value = [];
    } finally {
        isLoading.value = false;
    }
};

onMounted(fetchStocks);
</script>

<style scoped>
.stock_status_text {
    color: #9ca3af;
    text-align: center;
    padding: 2rem 0;
}
</style>
